/**
 * La función valida si el posting está convertido en Full (postingIdNew).
 * @param {string} urlPosting
 * @param {*} postingId
 * @param {*} postingIdNew
 * @returns string con la url para ir a la ficha del aviso
 */
const getUrlPosting = (urlPosting, postingId, postingIdNew = false) => {
  // Ejemplo de urlPosting: "depa-a-estrenar-142535238.html"
  const infoUrlPostingArray = urlPosting && urlPosting.split('.')[0].split('-');
  if (infoUrlPostingArray) {
    infoUrlPostingArray.pop();
  }
  const infoUrlPosting = infoUrlPostingArray && infoUrlPostingArray.join('-');
  return `${infoUrlPosting}-${postingIdNew || postingId}.html`;
};

export { getUrlPosting };
